import React, { useEffect, useState } from "react";
import { Button, Card, Col, Form, Input, Modal, notification, Row, Select, Table, Tabs, Tag, Upload } from "antd";

import { CloseOutlined, CloudUploadOutlined, DeleteOutlined, ExclamationCircleOutlined, FileDoneOutlined, PlusOutlined, SearchOutlined } from "@ant-design/icons";
import { getBase64, retornaSoLetras } from "../../../services/funcoes";
import api from "../../../services/api";
import moment from "moment";
import { FormatNumber } from "../../../ValueObjects";
import SelectPaginacao from "../../selects/selectPaginacao";
import InputPreco from "../../inputPreco";

export default function ModalDocsFiscaisCTe({ pages, notaTemp, setNotaTemp, form, exibirModal, fecharModal, listaDocs, setListaDocs, arquivoBase64, setArquivoBase64, arquivo, setArquivo }) {
    const [carregando, setCarregando] = useState(false);
    const [carregandoButton, setCarregandoButton] = useState(false);
    const [atualizaBotao, setAtualizaBotao] = useState(false);
    const [apenasTab1, setApenasTab1] = useState(false);
    const [apenasTab2, setApenasTab2] = useState(false);
    const [apenasTab3, setApenasTab3] = useState(false);
    const [abaSelecionada, setAbaSelecionada] = useState("1");
    const [listaDocsTab2, setListaDocsTab2] = useState([]);
    const [selectedRowKeys2, setSelectedRowKeys2] = useState([]);
    const [listaDocsTab3, setListaDocsTab3] = useState([]);
    const props = {
        name: 'file',
        multiple: false,
        showUploadList: false,
        maxCount: 1,
        disabled: !!arquivo,
        beforeUpload(file) {
            getBase64(file).then(base64 => {
                setArquivoBase64(base64.split('base64,')[1]);
                setArquivo(file);
            });
        }
    }

    const docsSelecionados2 = (newSelectedRowKeys) => {
        setSelectedRowKeys2(newSelectedRowKeys);
    };

    const rowSelection2 = {
        selectedRowKeys2,
        onChange: docsSelecionados2,
    };

    const onCloseModal = () => {
        Modal.confirm({
            title: 'Cancelar?',
            icon: <ExclamationCircleOutlined />,
            content: 'Deseja cancelar a operação?',
            okText: 'Sim',
            cancelText: 'Não',
            centered: true,
            onOk() {
                form.resetFields();
                fecharModal();
                removerNota();
            }
        })
    };

    useEffect(() => {
        setAbaSelecionada("1");
        definirCamposTab2();
        definirCamposTab3();
        setListaDocsTab3([]);
    }, [exibirModal])

    useEffect(() => {
        if (arquivo) {
            setApenasTab1(true);
        } else {
            setApenasTab1(false);
        }

        if (listaDocsTab2.length > 0) {
            setApenasTab2(true);
        } else {
            setApenasTab2(false);
        }

        if (listaDocsTab3.length > 0) {
            setApenasTab3(true);
        } else {
            setApenasTab3(false);
        }
    }, [arquivo, listaDocsTab2, listaDocsTab3])

    async function definirCamposTab2() {
        form.setFieldsValue({
            Filtro: null,
        });
        setListaDocsTab2([]);
    }

    async function definirCamposTab3() {
        form.setFieldsValue({
            cid_chave: undefined,
            cid_modelo: undefined,
            cid_numero: undefined,
            cid_id: null,
            cid_peso: 0,
            cid_valornf: 0
        })
    }

    async function buscarDoc() {
        setCarregandoButton(true);
        let Filtro = form.getFieldValue().Filtro || null;

        if (Filtro !== null && Filtro?.length === 44) {
            let modelo = Filtro.substring(20, 22);
            if (modelo === "55") {
                await api.get(`ConhecimentoTransporte/ListarDocumentos?Chave=${Filtro}`).then(
                    res => {
                        let retorno = [res.data];
                        if (retorno.length === 0) {
                            retornoNull();
                        } else {
                            adicionarDoc(retorno);
                        }
                    }
                ).catch(
                    error => {
                        retornoNull()
                        console.log(error);
                    }
                ).finally(
                    () => {
                        setCarregandoButton(false)
                    }
                )
            } else {
                notification.warning({ message: 'Atenção!', description: 'Chave da Nota não é de um documento fiscal modelo 55' });
                setCarregandoButton(false);
            }
        } else {
            notification.warning({ message: 'Atenção!', description: `${Filtro?.length > 0 && Filtro?.length < 44 ? 'Chave da Nota deve possuir 44 digítos' : 'Informe a Chave da Nota Fiscal'}` });
            setCarregandoButton(false);
        }
    }

    async function adicionarDoc(retorno) {
        if (abaSelecionada === "2") {
            let listaTemp = [...listaDocsTab2];
            let sequencia = listaTemp.length;

            retorno.forEach((doc, index) => {
                doc.doc_sequencia = sequencia + 1 + index;
                listaTemp.push(doc);
            });

            setListaDocsTab2(listaTemp);
            form.setFieldsValue({ Filtro: null });
        } else if (abaSelecionada === "3") {
            let dados = form.getFieldValue();
            let chavesExistentes = listaDocsTab3.map((doc) => doc.cid_chave);
            if (dados.cid_chave && dados.cid_id && dados.cid_modelo && dados.cid_valornf > 0) {
                if (chavesExistentes.includes(dados.cid_chave)) {
                    notification.warning({ message: 'Atenção!', description: 'Já existe um documento com a mesma chave adicionado.' });
                } else {
                    if (!validarCampos(dados)) return;
                    let infoCidade = await api.get(`Cidade/Buscar/${dados.cid_id}`).then(
                        res => {
                            if (res.data) {
                                return res;
                            } else
                                throw new Error(res);
                        }
                    ).catch(error => {
                        let mensagemErro = 'Erro ao buscar dados da Cidade.';
                        if (error.response) {
                            if (error.response.status === 500 && error.response.data.length) {
                                mensagemErro = error.response.data;
                            } else {
                                mensagemErro += ` Código: ${error.response.status}`;
                            }
                        } else {
                            mensagemErro += ` Detalhes: ${error.message}`;
                        }

                        notification.warning({
                            message: 'Atenção!',
                            description: mensagemErro
                        });

                        console.log(error);
                        return null; // Retorna null para indicar erro
                    });
                    if (infoCidade) {
                        let listaTemp = [...listaDocsTab3];

                        listaTemp.push({
                            sequencia: listaTemp.length + 1,
                            cid_chave: dados.cid_chave,
                            cid_id_munfinal: infoCidade.data.cid_id,
                            cid_descricao: infoCidade.data.cid_descricao,
                            est_sigla: infoCidade.data.estado.est_sigla,
                            cid_modelo: dados.cid_modelo,
                            cid_numero: dados.cid_numero,
                            cid_peso: dados.cid_peso,
                            cid_valornf: dados.cid_valornf
                        })

                        setListaDocsTab3(listaTemp);
                        notification.success({ message: 'Atenção!', description: 'Documento Fiscal adicionado.' });
                        definirCamposTab3();
                    }
                }
            } else {
                notification.warning({ message: 'Atenção!', description: 'Preencha todos os campos obrigatórios' });
            }
        }
    }

    function validarCampos(dados) {
        if (dados.cid_chave.length !== 44) {
            notification.warning({ message: 'Atenção!', description: 'Chave da nota deve possuir 44 digítos' });
            return false;
        }
        if (dados.cid_modelo !== '55') {
            notification.warning({ message: 'Atenção!', description: 'Deve ser informado um modelo 55' });
            return false;
        }
        return true;
    }

    async function retornoNull() {
        notification.warning({ message: 'Aviso!', description: 'Não foi encontrado nenhum Documento.' })
    }

    function incluirInfosDaChave(value) {
        let chave = value.currentTarget.value;

        if (chave.length >= 21) {
            let modelo = chave.slice(20, 22);
            form.setFieldsValue({
                cid_modelo: modelo
            })
        } else {
            form.setFieldsValue({ cid_modelo: undefined });
        }

        if (chave.length >= 31) {
            let numero = chave.slice(30, 34);
            form.setFieldsValue({
                cid_numero: numero
            })
        } else {
            form.setFieldsValue({ cid_numero: undefined })
        }
    }

    function verificaChave(value) {
        let chave = value.currentTarget.value;
        let apenasNumeros = (retornaSoLetras(chave) == "") ? true : false;
        if (!apenasNumeros) {
            notification.warning({ message: 'Atenção!', description: 'Chave da Nota deve conter apenas números' });
        }
    }

    function removerNota() {
        setArquivoBase64("");
        setArquivo(null);
        setAtualizaBotao(true);
        form.setFieldsValue({
            cid_dataemissao: null,
            cid_peso: null,
            cid_valornf: null
        })
    }

    function removerDoc(record) {
        let index = listaDocs.findIndex(doc => doc.sequencia === record.sequencia);
        let dadosTemp = [...listaDocsTab3];
        dadosTemp.splice(index, 1)

        dadosTemp.forEach((item, index) => {
            item.sequencia = index + 1;
        });
        setListaDocsTab3(dadosTemp);
    }

    function salvarDocs() {
        setCarregando(true);
        const chavesExistentes = [...listaDocs, ...notaTemp].map(doc => doc.cid_chave);

        if (abaSelecionada === "1") {
            api.post(`NotaFiscalEntrada/ImportarXML`, JSON.stringify(arquivoBase64), {
                headers: { 'Content-Type': 'application/json;charset=utf-8' }
            }).then(res => {
                const novoXML = [res.data];
                const notasValidas = novoXML.filter(nota => !chavesExistentes.includes(nota.cid_chave));
                if (notasValidas.length === 0) {
                    notification.warning({ message: 'Atenção!', description: 'Essa nota já está vinculada ao CTe atual' });
                    removerNota();
                    return;
                } else {
                    const todasNotas = [...notaTemp, ...notasValidas];
                    const notasComSequencia = todasNotas.map((doc, index) => ({ ...doc, sequencia: index + 1 }));
                    setNotaTemp(notasComSequencia);
                    notification.success({ message: 'Notas adicionadas ao temporário', description: `Total de notas temporárias: ${todasNotas.length}` });
                    fecharModal();
                    removerNota();
                }
            }).catch(() => {
                notification.error({ message: 'Aviso!', description: 'Ocorreu um erro ao vincular a nota' });
                removerNota();
            }).finally(() => {
                setCarregando(false);
            });
        } else if (abaSelecionada === "2") {
            const docsSelecionados2 = listaDocsTab2.filter(doc => selectedRowKeys2.includes(doc.doc_sequencia));

            if (docsSelecionados2.length === 0) {
                notification.warning({ message: 'Atenção!', description: 'É necessário selecionar pelo menos um documento para vinculá-lo' });
                setCarregando(false);
                return;
            }
            const todasNotas = [...notaTemp];
            const notasComSequencia = todasNotas.map((doc, index) => ({ ...doc, sequencia: index + 1 }));
            setNotaTemp(notasComSequencia);
            notification.success({ message: 'Nota adicionada com sucesso!' });
            fecharModal();
            setCarregando(false);
        } else if (abaSelecionada === "3") {
            if (listaDocsTab3.length === 0) {
                notification.warning({
                    message: 'Atenção!',
                    description: 'É necessário adicionar pelo menos um documento para vinculá-lo'
                });
                setCarregando(false);
                return;
            }
            const todasNotas = [...notaTemp];
            const notasComSequencia = todasNotas.map((doc, index) => ({ ...doc, sequencia: index + 1 }));
            setNotaTemp(notasComSequencia);
            notification.success({ message: 'Nota adicionada com sucesso!' })
            fecharModal();
            setCarregando(false);
        }
    }

    function verificaNotas(novaNota, notas) {
        let chavesExistentes = notas.map((doc) => doc.cid_chave);
        let docsDuplicados = chavesExistentes.includes(novaNota.cid_chave);
        if (docsDuplicados) {
            return false;
        } else {
            return true;
        }
    }

    return (
        <div>
            <Modal centered
                confirmLoading={carregando}
                title="Importar Documento Fiscal"
                open={exibirModal}
                onCancel={onCloseModal}
                width={abaSelecionada === "1" ? 580 : "70%"}
                onOk={salvarDocs}
                closable={false}
                okText={
                    <>
                        <FileDoneOutlined /> Vincular Documento(s)
                    </>
                }
                cancelText={
                    <>
                        <CloseOutlined /> Cancelar
                    </>
                }
                maskClosable={false}
            >
                <div>
                    <Form layout="vertical" name="formDocsFiscais" form={form}>
                        <Tabs type="card" centered activeKey={abaSelecionada} onChange={(tab) => setAbaSelecionada(tab)} >
                            <Tabs.TabPane tab="Importação de Nota(s)" key="1" disabled={apenasTab2 || apenasTab3}>
                                <Row gutter={[8, 0]} align="middle" style={{ textAlign: 'center' }}>
                                    <Col span={24}>
                                        <Upload {...props} accept=".xml">
                                            {!arquivo && <div>
                                                <Row align="middle" gutter={[0, 8]}>
                                                    <Button className={`${atualizaBotao ? 'fade-in' : ''}`} type="primary" size="large" icon={<CloudUploadOutlined />} onClick={() => setAtualizaBotao(false)}>
                                                        Importar XML
                                                    </Button>
                                                </Row>
                                            </div>}
                                            <div className={`${arquivo ? 'fade-in' : ''}`}>
                                                {!!arquivo &&
                                                    <Row align="middle" gutter={[8, 0]} >
                                                        <Col span={24}>
                                                            <Card style={{ overflow: 'hidden', borderRadius: '10px' }}>
                                                                <Row align="middle" gutter={[8, 8]}>
                                                                    <Col>
                                                                        <svg
                                                                            t="1622205362360"
                                                                            class="icon"
                                                                            viewBox="0 0 1024 1024"
                                                                            version="1.1"
                                                                            xmlns="http://www.w3.org/2000/svg" p-id="2101" id="mx_n_1622205362361" data-spm-anchor-id="a313x.7781069.0.i7" width="40" height="40">
                                                                            <path
                                                                                d="M354.40128 0c-87.04 0-157.44 70.55872-157.44 157.59872v275.68128H78.72c-21.6576 0-39.36256 17.69984-39.36256 39.36256v236.31872c0 21.6576 17.69984 39.35744 39.36256 39.35744h118.24128v118.08256c0 87.04 70.4 157.59872 157.44 157.59872h472.63744c87.04 0 157.59872-70.55872 157.59872-157.59872V315.0336c0-41.74848-38.9888-81.93024-107.52-149.27872l-29.11744-29.12256L818.87744 107.52C751.5392 38.9888 711.39328 0 669.59872 0H354.4064z m0 78.72h287.20128c28.35456 7.0912 27.99616 42.1376 27.99616 76.8v120.16128c0 21.6576 17.69984 39.35744 39.36256 39.35744h118.07744c39.38816 0 78.87872-0.0256 78.87872 39.36256v512c0 43.32032-35.55328 78.87872-78.87872 78.87872H354.4064c-43.32544 0-78.72-35.5584-78.72-78.87872v-118.08256h393.91744c21.66272 0 39.36256-17.69472 39.36256-39.35744V472.64256c0-21.66272-17.69984-39.36256-39.36256-39.36256H275.68128V157.59872c0-43.32032 35.39456-78.87872 78.72-78.87872zM145.12128 507.36128h23.99744l39.36256 67.2 40.32-67.2h23.04l-50.88256 83.51744 54.72256 92.16h-24.96l-43.20256-75.83744-43.19744 75.83744h-23.04l54.71744-92.16-50.87744-83.51744z m154.55744 0h32.64l49.92 143.03744h0.96256l48.95744-143.03744h33.60256v175.67744h-22.08256v-106.55744c0-10.88 0.32256-26.56256 0.96256-47.04256h-0.96256l-52.79744 153.6h-19.2l-52.80256-153.6h-0.95744c1.28 22.4 1.92 38.72256 1.92 48.96256v104.63744H299.6736V507.36128z m214.08256 0h22.07744v155.52h69.12v20.15744h-91.19744V507.36128z" p-id="2102">
                                                                            </path>
                                                                        </svg>
                                                                    </Col>
                                                                    <Col>
                                                                        {arquivo.name}
                                                                    </Col>
                                                                    <Col>
                                                                        <Button size="middle" icon={<DeleteOutlined />} onClick={() => { removerNota(); }} />
                                                                    </Col>
                                                                </Row>
                                                            </Card>
                                                        </Col>
                                                    </Row>
                                                }
                                            </div>
                                        </Upload>
                                    </Col>
                                </Row>
                            </Tabs.TabPane>
                            <Tabs.TabPane tab="Vincular Nota(s) do Sistema" key="2" disabled={apenasTab1 || apenasTab3}>
                                <Row align="middle" gutter={[8, 0]}>
                                    <Col xs={24} sm={24} md={12} lg={12} xl={8}>
                                        <Form.Item label="Pesquise pela" name="Filtro">
                                            <Input placeholder="chave" maxLength={44} />
                                        </Form.Item>
                                    </Col>
                                    <Col style={{ marginTop: '14px' }}>
                                        <Button type="primary" size="small" loading={carregandoButton} icon={<SearchOutlined />} onClick={() => buscarDoc()}>Buscar</Button>
                                    </Col>
                                    <Col style={{ marginTop: '14px' }}>
                                        <Button size="small" icon={<CloseOutlined />} onClick={() => definirCamposTab2()}>Limpar</Button>
                                    </Col>
                                </Row>
                                <Table dataSource={listaDocsTab2} rowKey={(record) => record.doc_sequencia} columns={
                                    [
                                        {
                                            title: 'Sequência',
                                            width: 30,
                                            align: 'center',
                                            render: ({ doc_sequencia }) => (
                                                <Tag className="w-75">
                                                    <b>{doc_sequencia}</b>
                                                </Tag>
                                            )
                                        },
                                        {
                                            title: 'Chave de Acesso',
                                            align: 'left',
                                            render: ({ cid_chave }) => (
                                                <b>{cid_chave}</b>
                                            )
                                        },
                                        {
                                            title: 'Data Emissão',
                                            align: 'center',
                                            width: 200,
                                            render: ({ cid_dataemissao }) => (
                                                <b>{moment(cid_dataemissao).format('DD/MM/YYYY')}</b>
                                            )
                                        },
                                        {
                                            title: 'Modelo',
                                            align: 'center',
                                            width: 10,
                                            render: ({ cid_modelo }) => (
                                                <b>{cid_modelo}</b>
                                            )
                                        },
                                        {
                                            title: 'Número',
                                            align: 'center',
                                            width: 100,
                                            render: ({ cid_numero }) => (
                                                <b>{cid_numero}</b>
                                            )
                                        },
                                        {
                                            title: 'Destinatário',
                                            align: 'left',
                                            render: ({ razao_destinatario }) => (
                                                <b>{razao_destinatario}</b>
                                            )
                                        },
                                        {
                                            title: 'Valor Total (R$)',
                                            fixed: 'right',
                                            align: 'right',
                                            width: 100,
                                            render: ({ cid_valornf }) => (
                                                <div>
                                                    <b>R$ {FormatNumber(cid_valornf, true)}</b>
                                                </div>
                                            )
                                        }
                                    ]
                                } rowSelection={rowSelection2}
                                />
                            </Tabs.TabPane>
                            <Tabs.TabPane tab="Vincular Nota(s) Manualmente" key="3" disabled={apenasTab1 || apenasTab2}>
                                <Row align="middle" gutter={[8, 0]}>
                                    <Col xs={24} sm={24} md={16} lg={16} xl={7}>
                                        <Form.Item label="Chave" name="cid_chave" rules={[{ required: true }]}>
                                            <Input placeholder="Informe a chave de acesso" maxLength={44} onChange={(value) => incluirInfosDaChave(value)} onBlur={(value) => verificaChave(value)} />
                                        </Form.Item>
                                    </Col>
                                    <Col xs={24} sm={8} md={8} lg={8} xl={3}>
                                        <Form.Item label="Modelo" name="cid_modelo" rules={[{ required: true }]}>
                                            <Input placeholder="Informe o Modelo" disabled />
                                        </Form.Item>
                                    </Col>
                                    <Col xs={24} sm={8} md={8} lg={8} xl={3}>
                                        <Form.Item label="Número" name="cid_numero" rules={[{ required: true }]}>
                                            <Input placeholder="Informe o Número" disabled />
                                        </Form.Item>
                                    </Col>
                                    <Col xs={24} sm={16} md={12} lg={12} xl={5}>
                                        <Form.Item label="Cidade Final" name="cid_id" rules={[{ required: true }]}>
                                            <SelectPaginacao url="Cidade/listar" nameLabel="cid_descricao" placeholder="Selecione a Cidade" allowClear nameValue="cid_id" selecionarRegUnico="cid_id" form={form}
                                                conteudo={
                                                    cid => (
                                                        <Select.Option value={cid.cid_id} key={cid.key} label={`${cid.cid_id} - ${cid.cid_descricao}`}>
                                                            {cid.estado.est_sigla} - {cid.cid_descricao}
                                                        </Select.Option>
                                                    )
                                                }
                                            />
                                        </Form.Item>
                                    </Col>
                                    <Col xs={24} sm={12} md={6} lg={6} xl={3}>
                                        <InputPreco label="Peso" name="cid_peso" />
                                    </Col>
                                    <Col xs={24} sm={12} md={6} lg={6} xl={3}>
                                        <InputPreco label="Valor Total (R$)" name="cid_valornf" rules={[{ required: true }]} />
                                    </Col>
                                </Row>
                                <Row align="middle" gutter={[8, 0]} style={{ marginBottom: '10px' }}>
                                    <Col>
                                        <Button type="primary" size="small" icon={<PlusOutlined />} onClick={() => adicionarDoc()}>Adicionar Nota</Button>
                                    </Col>
                                    <Col>
                                        <Button size="small" icon={<CloseOutlined />} onClick={() => definirCamposTab3()}>Limpar Campos</Button>
                                    </Col>
                                </Row>
                                <Table dataSource={listaDocsTab3} columns={
                                    [
                                        {
                                            title: 'Sequência',
                                            width: 30,
                                            align: 'center',
                                            render: ({ sequencia }) => (
                                                <Tag className="w-75">
                                                    <b>{sequencia}</b>
                                                </Tag>
                                            )
                                        },
                                        {
                                            title: 'Chave de Acesso',
                                            width: 300,
                                            align: 'left',
                                            render: ({ cid_chave }) => (
                                                <b>{cid_chave}</b>
                                            )
                                        },
                                        {
                                            title: 'Destino',
                                            align: 'center',
                                            width: 150,
                                            render: ({ cid_descricao, est_sigla }) => (
                                                <b>{cid_descricao} - {est_sigla}</b>
                                            )
                                        },
                                        {
                                            title: 'Peso',
                                            width: 100,
                                            align: 'center',
                                            render: ({ cid_peso }) => (
                                                <b>{FormatNumber(cid_peso, true)}</b>
                                            )
                                        },
                                        {
                                            title: 'Valor Total (R$)',
                                            fixed: 'right',
                                            align: 'right',
                                            width: 100,
                                            render: ({ cid_valornf }) => (
                                                <b>{FormatNumber(cid_valornf, true)}</b>
                                            )
                                        },
                                        {
                                            title: 'Ações',
                                            dataIndex: '',
                                            align: 'center',
                                            key: 'x',
                                            width: 45,
                                            fixed: 'right',
                                            render: (record) => {
                                                return (
                                                    <div>
                                                        <Row align="middle" justify="center" gutter={[5, 0]}>
                                                            <Col>
                                                                <Button onClick={() => removerDoc(record)} icon={<DeleteOutlined />} />
                                                            </Col>
                                                        </Row>
                                                    </div>
                                                );
                                            },
                                        },
                                    ]
                                } />
                            </Tabs.TabPane>
                        </Tabs>
                    </Form>
                </div>
            </Modal>
        </div>
    )
}